module.exports = __webpack_public_path__ + "img/pro-head-photo4.62824570.png";